import { getFactionImage, getFactionName, FACTIONS } from "../utils/factionLogic";

function FactionBadge() {
  const faction = localStorage.getItem("kisekidle-faction");
  if (!faction || !FACTIONS.includes(faction)) return null;

  const points = parseInt(localStorage.getItem("kisekidle-faction-points") || "0", 10);
  const img = getFactionImage(faction);
  const name = getFactionName(faction);

  return (
    <div className="sidebar-faction-badge">
      {img && <img src={img} alt={name} className="sidebar-faction-crest" />}
      <div className="sidebar-faction-info">
        <span className="sidebar-faction-name">{name}</span>
        <span className="sidebar-faction-points">⭐ {points} pts</span>
      </div>
    </div>
  );
}

export default FactionBadge;
